import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { Oppsummering } from "../../models/oppsummering.model";
import { OppsummeringApiService } from "./oppsummering-api-service";

export const oppsummeringResolver: ResolveFn<Oppsummering> = (route: ActivatedRouteSnapshot) => {
  const id = route.paramMap.get("id");
  return inject(OppsummeringApiService).getOppsummering(id!);
};
